import {Endpoint} from '@eryxcoop/appyx-comm';

export default class PossibleDuplicateLeadsEndpoint extends Endpoint {
    adaptValues(lead) {
        return {
            taxpayer_identification_number: lead.taxpayerIdentificationNumber,
            fantasy_name: lead.fantasyName,
            business_name: lead.businessName,
            lead_delivery_sites: lead.leadDeliverySites.map((leadDeliverySite) => ({
                address: leadDeliverySite.address,
                city: leadDeliverySite.city,
                postal_code: leadDeliverySite.postalCode,
            })),
        };
    }
}
